import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useTheme } from '../../../core/ui/ThemeContext';
import { useLanguage } from '../../../core/i18n/LanguageContext';

// On-prem-Schalter „MFA Pflicht" (general_settings 'mfa_required'). Im SaaS-Modus nicht gerendert (dort immer Pflicht).
const MfaSettings = ({ generalSettings, setGeneralSettings }) => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();
  const on = generalSettings.mfa_required === true;

  return (
    <div className="relative group mb-6">
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gradient-to-br from-gray-900/30 via-gray-800/20 to-gray-900/30 border border-white/20 backdrop-blur-2xl shadow-[0_8px_32px_rgba(0,0,0,0.4)]'
        : 'glass-light-card border border-slate-200 shadow-sm'
      } rounded-3xl`}></div>
      <div className="relative p-6 flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className={`w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0 ${isDarkMode ? 'bg-brand/20' : 'bg-brand/10'}`}>
            <ShieldCheck className={`w-5 h-5 ${isDarkMode ? 'text-blue-300' : 'text-brand'}`} />
          </div>
          <div>
            <h4 className={`text-lg font-semibold ${isDarkMode ? 'text-white drop-shadow-lg' : 'text-slate-900'}`}>
              {t('admin.mfa.requiredTitle')}
            </h4>
            <p className={`text-sm mt-1 ${isDarkMode ? 'text-white/60' : 'text-slate-600'}`}>
              {t('admin.mfa.requiredHint')}
            </p>
          </div>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={on}
          aria-label={t('admin.mfa.requiredTitle')}
          disabled={generalSettings.mfa_required === undefined}
          onClick={() => setGeneralSettings({ ...generalSettings, mfa_required: !on })}
          className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 disabled:opacity-40 ${
            on ? 'bg-brand' : (isDarkMode ? 'bg-white/20' : 'bg-slate-300')
          }`}
        >
          <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-all ${on ? 'left-[18px]' : 'left-0.5'}`} />
        </button>
      </div>
    </div>
  );
};

export default MfaSettings;
